import { Component, Input, ViewChild } from '@angular/core';
import 'moment/locale/id';
import Swal from 'sweetalert2';
import { BatteryRentRestService } from '../battery-rent-rest.service';
import { BatteryRentListComponent } from '../list/battery-rent-list.component';
import { APP_CONST } from '../../../app.const';
import { ImgUploadComponent } from '../../../libraries/img-upload/img-upload.component';

@Component({
  selector: 'app-tebus-modal',
  templateUrl: 'tebus-modal.component.html',
  styleUrls: ['../list/battery-rent-list.component.scss']
})
export class TebusModal {
  @ViewChild('imgUploadComponent') imgUploadComponent: ImgUploadComponent;
  @Input() batteryRent: any = {};
  isModalOpen: boolean = false;
  redeemType: string = 'tebus langsung';
  uploadEndpoint = APP_CONST.API_FILE;
  isLoading: boolean = false;
  typeMotor: string = '-';
  redeemPrice: string = '-';
  isImgUploadHidden = false;
  isEarlyAdopter: boolean = false;

  reRenderImgUpload() {
    this.isImgUploadHidden = true;  // Hilangkan komponen
    setTimeout(() => {
      this.isImgUploadHidden = false;  // Tampilkan kembali (re-render)
    }, 10);
  }

  formTebus = {
    redeemType: this.redeemType,
    bast: '',
    paymentProof: '',
    chassisNumber: '',
    batteryCode: ''
  };

  constructor(
    private _BatteryRentRest: BatteryRentRestService,

    public _batteryRentListComponent: BatteryRentListComponent,
  ) {}

  getRedeemPrice() {
      this.isLoading = true;
      // Here you would call your service to submit the data
      this._BatteryRentRest.getRedeemPrice(this.batteryRent.chassisNumber, this.batteryRent.totalMonths).subscribe({
        next: response => {
          this.typeMotor = response?.data?.typeMotor;
          this.redeemPrice = response?.data?.formatted;
          this.isEarlyAdopter = response?.data?.isEarlyAdopter;
          this.isLoading = false;
        },
        error: err => {
          const errorMessage = err.response.data.message;
          
          this.isLoading = false;
          Swal.fire('Error', `Gagal mendapatkan harga tebus: ${errorMessage}`, 'error')
          .then(() => {
            this.closeModal();
          });

        }
      });
  }

  resetFormData() {
    this.formTebus = {
      redeemType: this.redeemType,
      bast: '',
      paymentProof: '',
      chassisNumber: this.batteryRent.chassisNumber,
      batteryCode: this.batteryRent.batteryCode
    };
  }  

  openModal() {
    this.isModalOpen = true;
    this.getRedeemPrice();
    this.resetFormData();
    this.imgUploadComponent.doDeleteSingle();
    this.reRenderImgUpload();  // Paksa re-render
  
    this.formTebus.chassisNumber = this.batteryRent.chassisNumber;
    this.formTebus.batteryCode = this.batteryRent.batteryCode;
  }  

  closeModal() {
    this.isModalOpen = false;
    this.resetFormData();
  }
  
  onImageFinishUploaded(image: any, inputName: string) {
    if (image?.storageFileName) {
      this.formTebus[inputName] = image.storageFileName;
    } else {
      Swal.fire("Error", "Image upload failed, please try again.", 'error');
    }
  }

  isMandalaOrPatriot(type) {
    if (type.includes('415') || type.includes('700')) {
      return true;
    }
    return false;
  }

  onRedeemTypeChange() {
    this.imgUploadComponent.doDeleteSingle();
    this.formTebus.bast = '';
    this.formTebus.paymentProof = '';
    this.formTebus.redeemType = this.redeemType;
  }

  // Method to handle the submit action
  onSubmit(form) {
    // Inject value dari luar sebelum submit
    this.formTebus.chassisNumber = this.batteryRent.chassisNumber;
    this.formTebus.batteryCode = this.batteryRent.batteryCode;
    this.formTebus.bast = this.formTebus.bast || '';
    this.formTebus.paymentProof = this.formTebus.paymentProof || '';
  
    const requiredFields = ['redeemType', 'bast', 'chassisNumber', 'batteryCode'];
    
    if (this.formTebus.redeemType === 'tebus langsung') {
      requiredFields.push('paymentProof');
    }
  
    const emptyFields = requiredFields.filter(field => !this.formTebus[field]);

    if (emptyFields.length > 0) {
      const fieldList = emptyFields.join(', ');
      Swal.fire('Error', `Field berikut belum diisi: ${fieldList}`, 'error');
      return;
    }    
  
    this._BatteryRentRest.redeem(this.formTebus).subscribe({
      next: response => {
        Swal.fire('Success', 'Tebus berhasil!', 'success');
        this._batteryRentListComponent.callHookDirectly('init');
        this.closeModal(); // Close modal on success
      },
      error: err => {
        const errorMessage = err.response.data.message;
        Swal.fire('Error', `Proses tebus gagal: ${errorMessage}`, 'error');
      }
    });
  }
  
}